"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActivePassenger = exports.canceledAbortedPassengerStatuses = exports.canceledPassengerStatuses = exports.isClonablePassenger = exports.isDuplicablePassenger = exports.notFoundPassengerStatuses = exports.timeoutPassengerStatuses = exports.noridePassengerStatuses = exports.isPostBookedPassenger = exports.postBookedPassengerStatuses = exports.isPassengerGovBIssuer = exports.isPassengerGovAIssuer = exports.beforeBookedStatuses = exports.droppedStatuses = exports.isNoRidePaymentStatus = exports.noRidePaymentStatuses = exports.ON_HOLD_THRESOLD = void 0;
var __1 = require("..");
exports.ON_HOLD_THRESOLD = 14;
exports.noRidePaymentStatuses = [
    'DI_HPTLA',
    'DI_HPTLA_HPTLB',
    'DI_HPTLA_PTNT',
    'DI_AMBLER',
    'DI_PTNT',
];
var isNoRidePaymentStatus = function (payment) { return exports.noRidePaymentStatuses.includes(payment); };
exports.isNoRidePaymentStatus = isNoRidePaymentStatus;
exports.droppedStatuses = [
    'HPTL_EDIT_DROP',
    'PTNT_DROP',
    'HPTL_DROP',
    'TC_PTNT_DROP',
    'TC_HPTL_DROP',
];
exports.beforeBookedStatuses = __spreadArray(__spreadArray([], exports.droppedStatuses, true), [
    'CREATED',
    'DISPATCHING',
    'REQUESTED',
    'ABORTED',
    'TC_TPTR_NOT_FOUND',
    'TC_DISPATCH_TIMEOUT',
], false);
function getPassengerGovIssuer(payer, pmtIssuer, direction, mfuPlaceId, originPlaceId, destinationPlaceId) {
    if (payer !== 'GOV') {
        return null;
    }
    if (!pmtIssuer) {
        return null;
    }
    if (pmtIssuer === 'MFU') {
        return 'A';
    }
    var _a = direction === 'OUTBOUND' ? [originPlaceId, destinationPlaceId] : [destinationPlaceId, originPlaceId], originPlaceId_ = _a[0], destinationPlaceId_ = _a[1];
    var mfuIsOrigin = mfuPlaceId === originPlaceId_;
    var mfuIsDestination = mfuPlaceId === destinationPlaceId_;
    if (!mfuIsOrigin && !mfuIsDestination) {
        return null;
    }
    switch (pmtIssuer) {
        case 'ORIGIN':
            return mfuIsOrigin ? 'A' : 'B';
        case 'DESTINATION':
            return mfuIsDestination ? 'A' : 'B';
    }
    (0, __1.assertUnreachable)(pmtIssuer);
}
var isPassengerGovAIssuer = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return getPassengerGovIssuer.apply(void 0, args) === 'A';
};
exports.isPassengerGovAIssuer = isPassengerGovAIssuer;
var isPassengerGovBIssuer = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return getPassengerGovIssuer.apply(void 0, args) === 'B';
};
exports.isPassengerGovBIssuer = isPassengerGovBIssuer;
exports.postBookedPassengerStatuses = [
    'RUNNING',
    'ARRIVED',
    'WAIT_TPTR_CONFIRMATION',
    'WAIT_HPTL_CONFIRMATION',
    'WAIT_TC_CONFIRMATION',
    'CONFIRMED',
    'SUPPORT',
];
var isPostBookedPassenger = function (passenger) {
    return exports.postBookedPassengerStatuses.includes(passenger.status);
};
exports.isPostBookedPassenger = isPostBookedPassenger;
exports.noridePassengerStatuses = [
    'HPTL_NORIDE_AMBLER_FAULT',
    'HPTL_NORIDE_HPTL_FAULT',
    'HPTL_NORIDE_PTNT_FAULT',
    'HPTL_NORIDE_TPTR_FAULT',
    'PTNT_NORIDE_AMBLER_FAULT',
    'PTNT_NORIDE_HPTL_FAULT',
    'PTNT_NORIDE_PTNT_FAULT',
    'PTNT_NORIDE_TPTR_FAULT',
    'TPTR_NORIDE_AMBLER_FAULT',
    'TPTR_NORIDE_HPTL_FAULT',
    'TPTR_NORIDE_PTNT_FAULT',
    'TPTR_NORIDE_TPTR_FAULT',
];
exports.timeoutPassengerStatuses = ['TC_DISPATCH_TIMEOUT', 'HPTL_DISPATCH_TIMEOUT'];
exports.notFoundPassengerStatuses = [
    'TC_TPTR_NOT_FOUND',
    'HPTL_TPTR_NOT_FOUND',
    'TC_HPTL_TPTR_NOT_FOUND',
];
var isDuplicablePassenger = function (passenger) {
    return exports.noridePassengerStatuses.includes(passenger.status);
};
exports.isDuplicablePassenger = isDuplicablePassenger;
var isClonablePassenger = function (passenger) {
    return (0, __1.isIn)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], exports.notFoundPassengerStatuses, true), exports.timeoutPassengerStatuses, true), exports.noridePassengerStatuses, true), exports.canceledAbortedPassengerStatuses, true), exports.droppedStatuses, true), [
        // Support statuses
        'SUPPORT',
    ], false), passenger.status);
};
exports.isClonablePassenger = isClonablePassenger;
exports.canceledPassengerStatuses = [
    'HPTL_CANCEL',
    'PTNT_CANCEL',
    'TC_HPTL_CANCEL',
    'TC_PTNT_CANCEL',
    'HPTL_EDIT_CANCEL',
];
exports.canceledAbortedPassengerStatuses = __spreadArray(['ABORTED'], exports.canceledPassengerStatuses, true);
var isActivePassenger = function (passengerStatus) {
    return (0, __1.isIn)([
        'DELAYED',
        'DISPATCHING',
        'PREBOOKED',
        'BOOKED',
        'RUNNING',
        'ARRIVED',
        'WAIT_TPTR_CONFIRMATION',
        'WAIT_TC_CONFIRMATION',
        'WAIT_HPTL_CONFIRMATION',
    ], passengerStatus);
};
exports.isActivePassenger = isActivePassenger;
//# sourceMappingURL=passenger.js.map